import "./SplashGallery.css";
import photo1 from "./photos/pic1.jpg";
import photo2 from "./photos/pic2.jpg";
import photo3 from "./photos/pic3.jpg";
import photo4 from "./photos/pic4.jpg";
import photo5 from "./photos/pic5.jpg";
import photo6 from "./photos/pic6.jpg";
import photo7 from "./photos/pic7.jpg";
import photo8 from "./photos/pic8.jpg";

import { useNavigate } from "react-router";

const photos = [photo1, photo2, photo3, photo4, photo6, photo5, photo7, photo8];

const SplashGallery = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="SplashGalleryContainer">
        <h3 className="galleryh3">Gallery</h3>
        <div className="galleryPictures-grid">
          {photos.map((photo, idx) => (
            <img key={idx} className="galleryPicture" alt={`Landscaping project ${idx + 1}`} src={photo} />
          ))}
        </div>
        <button className="galleryButton" onClick={()=>{
          navigate('/photos')
        }}>See Full Gallery</button>
      </div>
    </>
  );
};

export default SplashGallery;
